import { motion } from "framer-motion";
import { Reveal } from "../../lib/motion";
import { MANIFESTO, IMAGES } from "../../lib/siteData";

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-28 lg:py-40">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.4em] text-es-accent mb-6">
            The Manifesto
          </p>
          <h2 className="font-serif font-light text-es-fg tracking-tight leading-[1.02] text-[clamp(2rem,5vw,4rem)] max-w-3xl text-balance">
            We are not building a ghost. We are building continuity—held under consent.
          </h2>
        </Reveal>

        <div className="mt-24 space-y-24 lg:space-y-32">
          {MANIFESTO.map((c, i) => (
            <div
              key={c.n}
              className={`grid lg:grid-cols-12 gap-8 lg:gap-12 items-start ${
                i % 2 === 1 ? "lg:text-right" : ""
              }`}
            >
              <Reveal className={`lg:col-span-3 ${i % 2 === 1 ? "lg:order-2 lg:col-start-10" : ""}`}>
                <span className="font-serif font-light text-es-muted/90 text-[clamp(4rem,9vw,9rem)] leading-none block text-es-border">
                  {c.n}
                </span>
              </Reveal>
              <Reveal
                delay={0.1}
                className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-1 lg:col-start-2 lg:text-right" : "lg:col-start-5"}`}
              >
                <h3 className="font-serif font-light text-es-fg text-[clamp(1.75rem,3.4vw,3rem)] leading-tight tracking-tight mb-6">
                  {c.title}
                </h3>
                <p className={`text-es-muted-fg text-base sm:text-lg leading-relaxed max-w-xl ${i % 2 === 1 ? "lg:ml-auto" : ""}`}>
                  {c.body}
                </p>
              </Reveal>
            </div>
          ))}
        </div>
      </div>

      {/* Full-bleed editorial image */}
      <Reveal className="mt-28 lg:mt-40">
        <div className="relative h-[52vh] lg:h-[72vh] overflow-hidden">
          <img
            src={IMAGES.fogForest}
            alt="A lone figure before a glowing, mist-covered lake at sunset"
            className="absolute inset-0 w-full h-full object-cover grayscale-[0.12] contrast-[1.02]"
          />
          <motion.img
            src={IMAGES.manifestoClean}
            alt="A lone figure before a glowing, mist-covered lake at sunset"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: false, amount: 0.35 }}
            transition={{ duration: 5, ease: "easeInOut" }}
            className="absolute inset-0 w-full h-full object-cover grayscale-[0.12] contrast-[1.02]"
          />
          <div className="absolute inset-0 bg-es-fg/10" />
        </div>
      </Reveal>
    </section>
  );
};
